<template>
	<header class="header">
		<div class="header__left">
			<router-link to="/" class="header-logo">
				<img
					class="header-logo__logo"
					src="@/assets/cw-logo.svg"
					alt="Colorway Logo"
				/>
			</router-link>
		</div>

		<div class="header__center">
			<h1 v-if="this.$store.getters.site == 'GB' " class="header__title flag flag--uk" data-main-title>
				Colorway New Dashboard | <span data-loc-text> {{ this.userInfo.site }} </span>
			</h1>
			<h1 v-if="this.$store.getters.site == 'NL' " class="header__title flag flag--nl" data-main-title>
				Colorway New Dashboard | <span data-loc-text> {{ this.userInfo.site }} </span>
			</h1>
			<h1 v-if="this.$store.getters.site == 'US' " class="header__title flag flag--us" data-main-title>
				Colorway New Dashboard | <span data-loc-text> {{ this.userInfo.site }} </span>
			</h1>
			<h1 v-if="this.$store.getters.site == 'AU' " class="header__title flag flag--au" data-main-title>
				Colorway New Dashboard | <span data-loc-text> {{ this.userInfo.site }} </span>
			</h1>
			<h1 v-if="this.$store.getters.site == 'HK' " class="header__title flag" data-main-title>
				Colorway New Dashboard | <span data-loc-text> {{ this.userInfo.site }} </span>
			</h1>
			<h1 v-if="this.$store.getters.site == '' " class="header__title flag" data-main-title>
				Colorway New Dashboard | <span data-loc-text> Please login </span>
			</h1>
			<HeaderNav v-bind:userInfo="this.userInfo"></HeaderNav>
		</div>

		<div class="header__right">
			<HeaderBtns v-if="$store.getters.isAuthenticated" v-bind:userInfo="this.userInfo"></HeaderBtns>
		</div>
	</header>
</template>

<script>
import Vue from "vue";
import axios from "axios";

import HeaderNav from "@/components/header/HeaderNav.vue";
import HeaderBtns from "@/components/header/HeaderBtns.vue";

export default Vue.extend({
	name: "SiteHeader",
	components: {
		HeaderNav,
		HeaderBtns
	},
	
	data() {
		return {
		userInfo: {},
		};
	},
	mounted() {
		{		
			this.getTaskList();
		}
	},
	computed: {
		loginStatus() {
			return this.$store.getters.isAuthenticated;
		}
	},
	watch: {
		loginStatus(newvalue, oldvalue) {
			if (newvalue == true) {
				console.log("Login status changed.... ");
				this.getTaskList();
			}
		}
	},
	methods: {

		getTaskList() {
			axios.get('https://new.colorwayrb.com/backend/checksession.php?sessionid=' + (this.$store.getters.sessionid) ).then(response => {
				this.userInfo = response.data;
				console.log(response.data);
				
				if (response.data.site == "SESSION_TIMEOUT") {
					alert("Session timeout, please login again...");
					
					this.$store.dispatch("authLogout");
					this.$router.push("/");
				}
				
			});
		},
	}
	
});
</script>

<style lang="scss" scoped>
.header {
	display: flex;
	position: relative;
	justify-content: space-between;

	background: $color2;
	height: 80px;
	width: 100%;

	&__title {
		letter-spacing: 1.05px;
		text-align: center;
		margin-top: 10px;
		font-size: 22px;
		color: $color1;

		position: relative;
		text-shadow: 1px 1px black;
		text-transform: uppercase;
		font-weight: 500;

		&.flag::after {
			display: inline-block;
			height: 20px;
			width: 30px;
			content: "";

			transform: translateY(-48%);
			position: absolute;
			margin-left: 10px;
			top: 50%;

			background-position: center;
			background-size: cover;
		}

		&.flag--uk::after {
			background-image: url("../../assets/uk-flag.svg");
		}
		
		&.flag--nl::after {
			background-image: url("../../assets/nl-flag.svg");
		}

		&.flag--us::after {
			background-image: url("../../assets/usa-flag.svg");
		}

		&.flag--au::after {
			background-image: url("../../assets/aus-flag.svg");
		}
	}

	&__left,
	&__right {
		display: flex;
		position: relative;
		z-index: 2;
	}

	&__left {
		justify-content: center;
		align-items: center;
		margin-left: 15px;
	}

	&__center {
		// padding: 5px 0;
		height: 100%;
		width: 100%;
		left: 0;
		top: 0;

		display: flex;
		justify-content: space-between;
		flex-direction: column;

		position: absolute;
		z-index: 1;
	}

	&__right {
		margin-right: 10px;
	}
}
</style>


